import { Box, Stack, useTheme } from "@mui/material"

export function SideDrawerContainer({ children }: { children: any }) {
    const theme = useTheme()
    return <Stack
        className="rightHandMenu"
        width={"100%"}
        maxWidth={"25rem"}
        borderLeft={"1px solid " + theme.palette.pebble.main}
        height={"100%"}
        flex={1}
        overflow="auto"
    >
        {children}
    </Stack>
}